import React, { useMemo } from "react";

import { Box } from "@chakra-ui/react";
import { useMediaQuery } from "hooks/useMediaQuery";

import { Heading4 } from "ui/typography";

import { IIndividualContentItemProps } from "./types";

export const IndividualContentItem = (props: IIndividualContentItemProps) => {
  const {
    title,
    content,
    isContentWrapperBelow745,
    isContentWrapperBelow600,
    individualContentItemClassName,
    individsContentItemHeaderClassName,
  } = props;
  const isLgScreen = useMediaQuery("(min-width: 1650px)");

  const individualContentItemWrapperClassName = useMemo(() => {
    let classNames = "flex flex-col gap-1 h-fit";
    if (isContentWrapperBelow600) {
      classNames += " basis-[100%]";
    } else if (isContentWrapperBelow745) {
      classNames += " basis-[45%] w-full max-w-[322.2px]";
    } else {
      classNames += ` ${individualContentItemClassName || "basis-[30%] w-full"} ${isLgScreen ? "max-w-[30%]" : "max-w-[237.9px]"}`;
    }

    return classNames;
  }, [isContentWrapperBelow745, isContentWrapperBelow600, isLgScreen]);

  if (!title && !content) return <></>;

  return (
    <Box className={individualContentItemWrapperClassName}>
      <Heading4
        textColor="#718096"
        lineHeight="22.4px"
        className={`h-[22px] ${individsContentItemHeaderClassName || ""}`}
        fontSize="14px"
      >
        {title}
      </Heading4>
      <Box
        css={{
          minHeight: "24px",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "24px",
          color: "#101828",
          textTransform: "capitalize",
        }}
      >
        {content}
      </Box>
    </Box>
  );
};
